import {
    getSubjectGrades,
    GetSubjectGradesQueryParams,
    getCourseContainerGroups,
    GetCourseContainerQueryParams,
    CourseContainerGroups,
} from '@yandex-int/k-common/client/api';
import type { SubjectGrades } from '@yandex-int/k-common';
import { QueryConfig, useQuery } from 'react-query';
import { getUniqueQueryKeys } from 'utils/getUniqueQueryKey';

const QUERY_KEYS = getUniqueQueryKeys(['getSubjectGrades', 'getCourseContainerGroups']);

export function useSubjectGrades(
    queryParams: GetSubjectGradesQueryParams = {},
    queryConfig?: QueryConfig<SubjectGrades>
) {
    const { autoassigned, isAvailableToTeacher, subjects } = queryParams;

    return useQuery(
        [QUERY_KEYS.getSubjectGrades, autoassigned, isAvailableToTeacher, subjects],
        () => getSubjectGrades(queryParams),
        {
            staleTime: Infinity,
            ...queryConfig,
        }
    );
}

export function useCourseContainerGroups(
    queryParams: GetCourseContainerQueryParams = {},
    queryConfig?: QueryConfig<CourseContainerGroups>
) {
    return useQuery([QUERY_KEYS.getCourseContainerGroups], () => getCourseContainerGroups(queryParams), {
        // в админке меняется редко
        staleTime: Infinity,
        ...queryConfig,
    });
}
